module.exports = __webpack_public_path__ + "assets/img/block-left-187e14c0.png";